import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";

export class Service extends BaseModel {

	id: string
	title: string
	description: string;
	price: number;
	unitName: string
	invoicingType: string
	invoicingPeriod: string;
	categoryId: string

}

export class ServiceDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static description: AttributeDescriptor = {validation: []}
	static price: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED, ValidationTypes.NUMERIC]}
	static unitName: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static categoryId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
}

export enum unitTypes {
	PER_HOUR = 'Po satu',
	PER_DAY = 'Po danu',
	PER_MONTH = 'Mesečno',
	PER_YEAR = 'Godišnje',
	PER_PIECE = 'Po usluzi'
}
